module.exports = __webpack_public_path__ + "static/ank-1d237a4786c93a755d5b2ddc3fbde3e2.jpg";